var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutralexpression(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01026 47.2678H61.1929M58.2798 0.599609H67.6016V9.90417M9.9233 0.599609H0.601562V9.90417M9.9233 67.4762H0.601562V58.1716M58.2798 67.4762H67.6016V58.1716",
    stroke: "#004276",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2479 46.919C17.1404 46.9416 17.0313 46.9604 16.9206 46.9752C14.5176 47.296 12.3096 45.6079 11.9888 43.2049L11.2969 38.0216C10.9761 35.6186 12.6642 33.4106 15.0672 33.0898M52.4607 47.0143C54.621 47.0075 56.4984 45.4062 56.7923 43.2049L57.4843 38.0216C57.7605 35.9524 56.5471 34.0276 54.6703 33.3282M36.2008 46.7792V39.1425C36.2008 37.1115 37.4941 35.306 39.4171 34.6523L39.999 34.4457C41.1823 34.0435 42.4361 33.8915 43.6812 33.9993C44.9262 34.107 46.1353 34.4722 47.2319 35.0717L48.6117 35.826M31.6445 35.0958L29.7323 34.4459C28.5491 34.0437 27.2953 33.8916 26.0502 33.9994C24.8052 34.1071 23.5961 34.4723 22.4995 35.0718L21.1197 35.8261",
    stroke: "#004276",
    strokeMiterlimit: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3809 39.0088C27.3307 39.009 28.1006 39.7796 28.1006 40.7295C28.1003 41.6792 27.3306 42.449 26.3809 42.4492C25.4309 42.4492 24.6604 41.6794 24.6602 40.7295C24.6602 39.7794 25.4308 39.0088 26.3809 39.0088Z",
    fill: "#004276",
    stroke: "#004276"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3105 39.0088C44.2604 39.009 45.0303 39.7796 45.0303 40.7295C45.03 41.6792 44.2603 42.449 43.3105 42.4492C42.3606 42.4492 41.5901 41.6794 41.5898 40.7295C41.5898 39.7794 42.3605 39.0088 43.3105 39.0088Z",
    fill: "#004276",
    stroke: "#004276"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0901 40.372L46.1907 39.6918M25.6272 40.372L23.5266 39.6918M55.5521 27.1879C55.5373 28.1341 55.4579 29.0782 55.3144 30.0135L53.1775 40.991C53.1775 48.4002 49.9721 53.6785 44.3351 58.4868C41.2012 61.1601 37.7414 62.7719 34.8648 62.7719C31.9883 62.7719 28.5285 61.1601 25.3946 58.4868C19.7577 53.6785 16.5522 48.4002 16.5522 40.991L14.6756 28.9307C13.4838 16.878 22.9516 6.42773 35.0631 6.42773C41.8819 6.42773 47.8299 9.72863 51.5357 14.7333",
    stroke: "#004276",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7899 18.2207C42.7899 18.2207 22.6408 20.8975 16.0664 36.1553M41.0889 22.6229C41.0889 22.6229 49.479 24.4946 53.9387 36.1552M30.0392 51.375C31.4875 52.8867 33.6763 51.1331 34.9816 52.4096C36.4514 51.2137 38.1713 52.8059 39.9241 51.375",
    stroke: "#004276",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5131 56.5961V56.7288M57.5131 61.7084V61.841M54.8907 59.2186H55.0233M60.0031 59.2186H60.1357M55.3553 17.4579V17.5905M55.3553 22.5702V22.7028M52.7327 20.0804H52.8653M57.8451 20.0804H57.9777M11.1341 6.1582V6.29092M11.1341 11.2705V11.4031M8.51172 8.78073H8.64432M13.6241 8.78073H13.7567M12.0345 52.0731V52.2057M12.0345 57.1854V57.318M9.41205 54.6956H9.54465M14.5244 54.6956H14.657M33.7306 56.1134H36.2336",
    stroke: "#004276",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralexpression);
export default __webpack_public_path__ + "static/media/neutral expression.d99984e1c299609f491ea03429e83e0c.svg";
export { ForwardRef as ReactComponent };